import {DHLCityMaintenanceRequest} from '../pages/dhl-city-maintenance/interface/dhl-city-maintenance-request';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {PageResp} from '../../../core/models/page/page-response';
import {DHLCityMaintenanceTableData} from '../pages/dhl-city-maintenance/interface/dhl-city-maintenance-table-data';

@Injectable({
  providedIn: 'root'
})
export class DHLCityMaintenanceService {

  private baseUrl = `${environment.logisticsApiUrl}/dhl/city`;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient
  ) { }

  getData(request: DHLCityMaintenanceRequest): Observable<PageResp<DHLCityMaintenanceTableData>> {
    return this.http.post<PageResp<DHLCityMaintenanceTableData>>(this.baseUrl + '/findWarehousingDhlCity', request, this.httpOptions);
  }

  saveCityChanges(request: DHLCityMaintenanceTableData[]): Observable<void> {
    return this.http.post<void>(this.baseUrl + '/saveWarehousingDhlCity', request, this.httpOptions);
  }
}
